import React, { useState } from "react";
import Popover from "@material-ui/core/Popover";
import moment from "moment";

const MAX_SHOWN = 5;

export function CaseFileMailIcon({ mailLogs }) {
  const [anchor, setAnchor] = useState(null);
  if (!mailLogs?.length) return null;
  const shown = mailLogs.slice(0, MAX_SHOWN);
  const extra = mailLogs.length - MAX_SHOWN;
  return (
    <>
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => setAnchor(e.currentTarget)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setAnchor(e.currentTarget);
          }
        }}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 1,
          color: "#0284c7",
          verticalAlign: "middle",
        }}
        title="Mail history — click for details"
      >
        <i
          className="mdi mdi-email-check-outline"
          style={{ fontSize: "1.125rem", lineHeight: 1, display: "block" }}
          aria-hidden
        />
      </span>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <div style={{ padding: "14px 16px", maxWidth: 320 }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10, color: "#0f172a" }}>
            Mail History ({mailLogs.length})
          </div>
          {shown.map((log, idx) => (
            <div
              key={log.id ?? idx}
              style={{ marginBottom: idx < shown.length - 1 ? 10 : 0 }}
            >
              <div style={{ fontWeight: 600, fontSize: 13, color: "#0369a1" }}>
                {log.created_at ? moment(log.created_at).format("Do MMM YYYY, HH:mm") : "—"}
              </div>
              <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                {log.user?.name ?? "—"}
              </div>
            </div>
          ))}
          {extra > 0 && (
            <div style={{ marginTop: 8, fontSize: 12, color: "#94a3b8" }}>
              +{extra} more
            </div>
          )}
        </div>
      </Popover>
    </>
  );
}
